<template>
    <div>
        <!-- TAB HEAD  -->
        <v-row>
            <v-col cols="6">
                <h1 class="headline font-weight-light mb-3">
                    <span class="link-a cur-p" @click="back()">
                        RETURN PARTS</span
                    >
                    / PRINT
                </h1>
            </v-col>
            <v-spacer></v-spacer>

            <v-col cols="6" class="text-right">
                <v-btn rounded small @click="print()" v-if="isAndroid == false">
                    <v-icon class="mr-1" color="info">mdi-printer</v-icon>
                    Print</v-btn
                >
            </v-col>
        </v-row>

        <div id="printDiv">
            <div id="main">
                <v-row>
                    <v-col cols="4"> </v-col>
                    <v-col cols="5"> </v-col>
                    <v-col cols="3" style="text-align: right">
                        <img
                            style="text-align: right"
                            src="../../assets/return/hp_enterprise_small.fw.png"
                    /></v-col>
                </v-row>
                <v-row>
                    <v-col cols="4"> </v-col>
                    <v-col cols="5">
                        <div
                            style="
                                margin-top: 36px;
                                font-size: 28px;
                                font-weight: bold;
                            "
                        >
                            {{ text_h_how }}
                        </div>
                    </v-col>
                    <v-col cols="3" style="text-align: right"> </v-col>
                </v-row>

                <v-row class="ml-1 mr-1" style="margin-top: 30px">
                    <v-col style="margin-top: 15px" cols="10">
                        Engineer Name:
                        <span style="border-bottom: 1px solid #000">{{
                            data_print.ce_name
                        }}</span>
                    </v-col>
                    <v-col style="margin-top: 15px" cols="2"></v-col>
                    <v-col style="margin-top: 15px" cols="5"
                        >Engineer Badge ID:
                        <span style="border-bottom: 1px solid #000">{{
                            data_print.hp_siteid
                        }}</span>
                    </v-col>
                    <v-col style="margin-top: 15px" cols="5"
                        >Engineer Phone Number:
                        <span style="border-bottom: 1px solid #000">{{
                            data_print.ce_tel
                        }}</span>
                    </v-col>
                    <v-col style="margin-top: 15px" cols="10">
                        Case ID:
                        <span style="border-bottom: 1px solid #000">{{
                            data_print.case_id
                        }}</span>
                        -53
                        <span style="border-bottom: 1px solid #000; color:#FFF;"
                            >xxxxx</span
                        >-<span
                            style="border-bottom: 1px solid #000; color:#FFF;"
                            >xxxxx</span
                        >
                    </v-col>
                    <v-col style="margin-top: 15px" cols="10">
                        RMA Number:
                        <span
                            style="border-bottom: 1px solid #000"
                            v-if="data_print.rma"
                            >{{ data_print.rma }}</span
                        >
                        <span
                            style="border-bottom: 1px solid #000; color:#FFF;"
                            v-else
                            >xxxxxxxxxxxxxxxxxxxx</span
                        >
                    </v-col>
                    <v-col style="margin-top: 15px" cols="10">
                        Customer Name:
                        <span style="border-bottom: 1px solid #000">{{
                            data_print.customer_name
                        }}</span>
                    </v-col>
                    <v-col style="margin-top: 15px" cols="10">
                        Customer Unit Serial Number:
                        <!-- <span style="border-bottom: 1px solid #000">{{
                            data_print.product_serial
                        }}</span> -->
                        <span style="border-bottom: 1px solid #000; color:#FFF;"
                            >xxxxxxxxxxxxxxxxxxxx</span
                        >
                    </v-col>
                </v-row>

                <v-row style="margin-top: 30px">
                    <v-col cols="1"></v-col>
                    <v-col cols="2">
                        <table>
                            <tr>
                                <td
                                    align="center"
                                    width="40%"
                                    style="border-bottom: 1px solid #000"
                                >
                                    <img
                                        v-if="data_print.product_group == 'PSG'"
                                        style="
                                            text-align: right;
                                            width: 15px;
                                            height: 15px;
                                        "
                                        src="../../assets/all/check.png"
                                    />
                                </td>

                                <td
                                    align="center"
                                    width="100px"
                                    class="text-left"
                                >
                                    <span class="font-18">PSG</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="2">
                        <table>
                            <tr>
                                <td
                                    align="center"
                                    width="40%"
                                    style="border-bottom: 1px solid #000"
                                >
                                    <img
                                        v-if="data_print.product_group == 'IPG'"
                                        style="
                                            text-align: right;
                                            width: 15px;
                                            height: 15px;
                                        "
                                        src="../../assets/all/check.png"
                                    />
                                </td>

                                <td
                                    align="center"
                                    width="100px"
                                    class="text-left"
                                >
                                    <span class="font-18">IPG</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="2">
                        <table>
                            <tr>
                                <td
                                    align="center"
                                    width="40%"
                                    style="border-bottom: 1px solid #000"
                                ></td>

                                <td
                                    align="center"
                                    width="100px"
                                    class="text-left"
                                >
                                    <span class="font-18">ISS</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="2">
                        <table>
                            <tr>
                                <td
                                    align="center"
                                    width="40%"
                                    style="border-bottom: 1px solid #000"
                                ></td>

                                <td
                                    align="center"
                                    width="100px"
                                    class="text-left"
                                >
                                    <span class="font-18">SWD</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                </v-row>
                <v-row style="margin-top: 30px">
                    <v-col cols="1"></v-col>
                    <v-col cols="2">
                        <table>
                            <tr>
                                <td
                                    align="center"
                                    width="40%"
                                    style="border-bottom: 1px solid #000"
                                ></td>

                                <td
                                    align="center"
                                    width="100px"
                                    class="text-left"
                                >
                                    <span class="font-18">BCS</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="2">
                        <table>
                            <tr>
                                <td
                                    align="center"
                                    width="40%"
                                    style="border-bottom: 1px solid #000"
                                ></td>

                                <td
                                    align="center"
                                    width="100px"
                                    class="text-left"
                                >
                                    <span class="font-18">NETW</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="2">
                        <table>
                            <tr>
                                <td
                                    align="center"
                                    width="40%"
                                    style="border-bottom: 1px solid #000"
                                ></td>

                                <td
                                    align="center"
                                    width="100px"
                                    class="text-left"
                                >
                                    <span class="font-18">MVS</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="2">
                        <table>
                            <tr>
                                <td
                                    align="center"
                                    width="40%"
                                    style="border-bottom: 1px solid #000"
                                ></td>

                                <td
                                    align="center"
                                    width="100px"
                                    class="text-left"
                                >
                                    <span class="font-18">OTHERS</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                </v-row>

                <v-row style="margin-top: 30px">
                    <v-col cols="10">
                        Part Number:
                        <span style="border-bottom: 1px solid #000">{{
                            data_print.part_name
                        }}</span>
                    </v-col>
                </v-row>

                <v-row style="margin-top: 30px">
                    <v-col style="margin-top: 15px" cols="2"> DOA Type </v-col>
                    <v-col
                        style="margin-top: 15px; border-bottom: 1px solid #000"
                        cols="1"
                    >
                        <img
                            v-if="data_print.return_reason === 'newpart'"
                            style="text-align: right; width: 15px; height: 15px"
                            src="../../assets/all/check.png"
                        />
                    </v-col>
                    <v-col style="margin-top: 15px" cols="3">
                        DOA/Functional Failure (55)
                    </v-col>
                    <v-col style="margin-top: 15px" cols="6">
                        Part <b>ที่ได้รับการอยู่ในสภาพดีแต่ใช้งานไม่ได้</b>
                    </v-col>

                    <v-col style="margin-top: 15px" cols="2"> </v-col>
                    <v-col
                        style="margin-top: 15px; border-bottom: 1px solid #000"
                        cols="1"
                    >
                        <img
                            v-if="data_print.return_reason === 'defective'"
                            style="text-align: right; width: 15px; height: 15px"
                            src="../../assets/all/check.png"
                        />
                    </v-col>
                    <v-col style="margin-top: 15px" cols="3">
                        Physically Damaged (PD)
                    </v-col>
                    <v-col style="margin-top: 15px" cols="6">
                        Part <b>ที่ได้รับชำรุดเสียหาย เช่น แตก หรือ บุบ</b>
                    </v-col>

                    <v-col style="margin-top: 15px" cols="2"> </v-col>
                    <v-col
                        style="margin-top: 15px; border-bottom: 1px solid #000"
                        cols="1"
                    >
                        <img
                            v-if="data_print.return_reason === 'invalid'"
                            style="text-align: right; width: 15px; height: 15px"
                            src="../../assets/all/check.png"
                        />
                    </v-col>
                    <v-col style="margin-top: 15px" cols="3">
                        Part Missing/Empty Box (PM)
                    </v-col>
                    <v-col style="margin-top: 15px" cols="6">
                        Part
                        <b>ที่ได้รับ มีชิ้นส่วนไม่ครบ หรือได้รับกล่องเปล่า</b>
                    </v-col>

                    <v-col style="margin-top: 15px" cols="2"> </v-col>
                    <v-col
                        style="margin-top: 15px; border-bottom: 1px solid #000"
                        cols="1"
                    >
                        <img
                            v-if="data_print.return_reason === 'mismatch'"
                            style="text-align: right; width: 15px; height: 15px"
                            src="../../assets/all/check.png"
                        />
                    </v-col>
                    <v-col style="margin-top: 15px" cols="3">
                        Wrong Part in Box (WP)
                    </v-col>
                    <v-col style="margin-top: 15px" cols="6">
                        Part <b>ในกล่องไม่ตรงกับ </b> Part number
                        <b> ข้างกล่อง</b>
                    </v-col>

                    <v-col style="margin-top: 15px" cols="2"> </v-col>
                    <v-col
                        style="margin-top: 15px; border-bottom: 1px solid #000"
                        cols="1"
                    >
                        <img
                            v-if="data_print.return_reason === 'acc-lost'"
                            style="text-align: right; width: 15px; height: 15px"
                            src="../../assets/all/check.png"
                        />
                    </v-col>
                    <v-col style="margin-top: 15px" cols="3">
                        Assembly Issue (AI)
                    </v-col>
                    <v-col style="margin-top: 15px" cols="6">
                        Part <b>ที่ได้รับประกอบมาไม่เรียบร้อย</b>
                    </v-col>
                </v-row>

                <v-row style="margin-top: 30px">
                    <v-col cols="2"> Failure Symptom: </v-col>
                    <v-col cols="10" style="border-bottom: 1px solid #000">
                        <span>{{ data_print.return_remark }}</span>
                    </v-col>
                    <v-col
                        cols="12"
                        style="border-bottom: 1px solid #000; margin-top: 25px"
                    >
                        <span style="color: #fff">.</span>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    mounted() {
        this.part_issue_id = this.$route.params.part_issue_id
        this.get_data()
    },
    computed: {
        ...mapState(["isLoading"]),
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        async get_data() {
            this.mutateIsLoading()
            await axios
                .get(url + "engineer/return-part-view/" + this.part_issue_id)
                .then((response) => {
                    this.mutateIsLoading()
                    this.data_print = response.data
                    this.chk_status = response.data.ce_status
                    this.text_h_how = "PART DOA FAILURE REPORT"
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        back() {
            if (this.role_type == "Engineer") {
                this.$router.push("/Onsite/Main/Return-Part")
            } else {
                this.$router.push("/Return-Part")
            }
        },
        print() {
            const localOptions = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                ],
                // "https://aitt.netlify.app/landscape.css",
            }

            this.$htmlToPaper("printDiv", localOptions, () => {
                // console.log(localOptions)
                // console.warn("done landscape")
            })
        },
    },
    data() {
        return {
            isAndroid: false,
            data_print: [],
            part_issue_id: 0,
            chk_status: "",
            text_h_how: "",
            role_type: localStorage.role_type,
        }
    },
}
</script>

<style scoped>
.fix-col-print-a {
    padding: 0px !important;
}
</style>
